import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      /* ================= NAV ================= */
      nav_home: 'Inicio',
      nav_plans: 'Planes',
      nav_benefits: 'Beneficios',
      nav_contact: 'Contacto',

      /* ================= HERO ================= */
      hero_title_main: 'Internet',
      hero_title_highlight: 'ULTRA',
      hero_subtitle: 'Sin Límites',

      hero_desc_line1_prefix:
        'Internet inalámbrico fijo residencial de hasta',
      hero_desc_line1_suffix: '.',

      hero_desc_line2:
        'Conexión estable. Soporte humano 24/7.',

      hero_cta_plans: 'Ver Planes',
      hero_cta_coverage: 'Verificar Cobertura',

      hero_coverage_message:
        'Hola, quiero saber si tengo cobertura en estas coordenadas:',
      hero_coverage_error:
        'No pudimos obtener tu ubicación. Por favor escríbenos manualmente.',

      /* ================= PLANS ================= */
      plans_title: 'Planes que se adaptan a ti',
      plans_subtitle: 'Simples. Claros. Sin letras pequeñas.',

      plans_tab_wireless: 'Internet Inalámbrico Fijo',
      plans_tab_5g: 'Internet 5G Ilimitado',
      plans_tab_fiber: 'Fibra Óptica',

      plans_sub_residential: 'Residencial',
      plans_sub_commercial: 'Comercial',

      plans_cta: 'Contratar ahora',
      plans_price_suffix: 'mes',

      /* ---- PLAN NAMES ---- */
      plan_basic: 'Básico',
      plan_standard: 'Estándar',
      plan_premium: 'Premium',

      plan_fiber_300: 'Fibra 300',
      plan_fiber_600: 'Fibra 600',
      plan_fiber_1g: 'Fibra 1G',

      plan_fiber_business_300: 'Fibra Business 300',
      plan_fiber_business_600: 'Fibra Business 600',
      plan_fiber_business_1g: 'Fibra Business 1G',

      plan_5g_unlimited: '5G Ilimitado',

      /* ---- FEATURES ---- */
      feature_fixed_wireless: 'Internet inalámbrico fijo',
      feature_unlimited: 'Ilimitado',
      feature_support_24_7: 'Soporte 24/7',
      feature_wifi_free: 'WiFi gratis',

      feature_static_ip: 'IP estática',
      feature_priority_support: 'Soporte prioritario',
      feature_redundancy: 'Redundancia',

      feature_fiber_dedicated: 'Fibra dedicada',
      feature_low_latency: 'Baja latencia',
      feature_router_included: 'Router incluido',
      feature_router_premium: 'Router premium incluido',
      feature_max_speed: 'Máxima velocidad',

      feature_business_fiber: 'Fibra dedicada empresarial',
      feature_sla: 'SLA',
      feature_sla_guaranteed: 'SLA garantizado',
      feature_sla_premium: 'SLA premium',

      feature_5g_network: 'Red 5G',
      feature_download_100: 'Hasta 100M de velocidad ⬇️',
      feature_upload_25: 'Hasta 25M de velocidad ⬆️',

      /* ================= BENEFITS ================= */
      benefits_title: '¿Por qué nos eligen?',
      benefits_subtitle: 'Simple. Porque entregamos lo que prometemos.',

      benefit_speed_title: 'Velocidad Máxima',
      benefit_speed_desc:
        'Fibra óptica real hasta 1 Gbps. Sin límites ni reducciones.',

      benefit_support_title: 'Soporte Humano 24/7',
      benefit_support_desc:
        'Respuesta inmediata por WhatsApp, llamada o chat. Siempre.',

      benefit_coverage_title: 'Cobertura en toda la Isla',
      benefit_coverage_desc:
        'Llegamos donde otros no pueden. Expansión constante.',

      /* ================= CONTACT ================= */
      contact_title: 'Hablemos',
      contact_subtitle: 'Te respondemos en menos de 24 horas. Siempre.',

      contact_name_placeholder: 'Nombre completo *',
      contact_email_placeholder: 'Correo electrónico *',
      contact_phone_placeholder: 'Teléfono (opcional)',
      contact_message_placeholder: '¿En qué podemos ayudarte? *',

      contact_submit: 'Enviar Mensaje',
      contact_sending: 'Enviando...',
      contact_success: '¡Mensaje enviado con éxito! Te contactaremos pronto.',
      contact_error: 'Por favor completa todos los campos obligatorios *',

      /* ================= FOOTER ================= */
      footer_description:
        'Internet de fibra óptica real. Velocidad sin límites y soporte humano 24/7.',
      footer_contact_title: 'Contáctanos',
      footer_location: 'Puerto Rico',
      footer_follow_title: 'Síguenos',
      footer_rights: 'Todos los derechos reservados.',
      footer_tagline: 'Internet de alta velocidad en Puerto Rico',

      /* ================= WHATSAPP ================= */
      whatsapp_message:
        '¡Hola! Quiero más información sobre los servicios de internet que ofrece TekNet.',
      whatsapp_aria: 'Chatear por WhatsApp',
    },
  },

  en: {
    translation: {
      /* ================= NAV ================= */
      nav_home: 'Home',
      nav_plans: 'Plans',
      nav_benefits: 'Benefits',
      nav_contact: 'Contact',

      /* ================= HERO ================= */
      hero_title_main: 'Internet',
      hero_title_highlight: 'ULTRA',
      hero_subtitle: 'No Limits',

      hero_desc_line1_prefix:
        'Residential fixed wireless internet up to',
      hero_desc_line1_suffix: '.',

      hero_desc_line2:
        'Stable connection. Human support 24/7.',

      hero_cta_plans: 'View Plans',
      hero_cta_coverage: 'Check Coverage',

      hero_coverage_message:
        'Hi, I would like to know if I have coverage at these coordinates:',
      hero_coverage_error:
        'We could not access your location. Please contact us manually.',

      /* ================= PLANS ================= */
      plans_title: 'Plans that fit you',
      plans_subtitle: 'Simple. Clear. No fine print.',

      plans_tab_wireless: 'Fixed Wireless Internet',
      plans_tab_5g: 'Unlimited 5G Internet',
      plans_tab_fiber: 'Fiber Optic',

      plans_sub_residential: 'Residential',
      plans_sub_commercial: 'Business',

      plans_cta: 'Sign up now',
      plans_price_suffix: 'month',

      /* ---- PLAN NAMES ---- */
      plan_basic: 'Basic',
      plan_standard: 'Standard',
      plan_premium: 'Premium',

      plan_fiber_300: 'Fiber 300',
      plan_fiber_600: 'Fiber 600',
      plan_fiber_1g: 'Fiber 1G',

      plan_fiber_business_300: 'Fiber Business 300',
      plan_fiber_business_600: 'Fiber Business 600',
      plan_fiber_business_1g: 'Fiber Business 1G',

      plan_5g_unlimited: 'Unlimited 5G',

      /* ---- FEATURES ---- */
      feature_fixed_wireless: 'Fixed wireless internet',
      feature_unlimited: 'Unlimited',
      feature_support_24_7: '24/7 support',
      feature_wifi_free: 'Free WiFi',

      feature_static_ip: 'Static IP',
      feature_priority_support: 'Priority support',
      feature_redundancy: 'Redundancy',

      feature_fiber_dedicated: 'Dedicated fiber',
      feature_low_latency: 'Low latency',
      feature_router_included: 'Router included',
      feature_router_premium: 'Premium router included',
      feature_max_speed: 'Maximum speed',

      feature_business_fiber: 'Business dedicated fiber',
      feature_sla: 'SLA',
      feature_sla_guaranteed: 'Guaranteed SLA',
      feature_sla_premium: 'Premium SLA',

      feature_5g_network: '5G Network',
      feature_download_100: 'Up to 100 Mbps download',
      feature_upload_25: 'Up to 25 Mbps upload',

      /* ================= BENEFITS ================= */
      benefits_title: 'Why choose us?',
      benefits_subtitle: 'Simple. We deliver what we promise.',

      benefit_speed_title: 'Maximum Speed',
      benefit_speed_desc:
        'True fiber optic up to 1 Gbps. No limits or throttling.',

      benefit_support_title: 'Human Support 24/7',
      benefit_support_desc:
        'Immediate response via WhatsApp, call, or chat. Always.',

      benefit_coverage_title: 'Island-wide Coverage',
      benefit_coverage_desc:
        'We reach where others cannot. Constant expansion.',

      /* ================= CONTACT ================= */
      contact_title: 'Let’s talk',
      contact_subtitle: 'We respond in less than 24 hours. Always.',

      contact_name_placeholder: 'Full name *',
      contact_email_placeholder: 'Email address *',
      contact_phone_placeholder: 'Phone (optional)',
      contact_message_placeholder: 'How can we help you? *',

      contact_submit: 'Send Message',
      contact_sending: 'Sending...',
      contact_success: 'Message sent successfully! We will contact you soon.',
      contact_error: 'Please complete all required fields *',

      /* ================= FOOTER ================= */
      footer_description:
        'True fiber optic internet. Unlimited speed and human support 24/7.',
      footer_contact_title: 'Contact us',
      footer_location: 'Puerto Rico',
      footer_follow_title: 'Follow us',
      footer_rights: 'All rights reserved.',
      footer_tagline: 'High-speed internet in Puerto Rico',

      /* ================= WHATSAPP ================= */
      whatsapp_message:
        'Hi! I would like more information about TekNet internet services.',
      whatsapp_aria: 'Chat via WhatsApp',
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
